import { LoadingSkeleton } from '@/generic/loader';
import {
  IpponCard,
  IpponHSpace,
  IpponHSpaceSlot,
  IpponIcon,
  IpponIconTile,
  IpponText,
  IpponVSpace,
} from '@ippon-ui/react';

export const RulesSelectionLoadingComponent = () => (
  <LoadingSkeleton>
    <IpponCard shadow="l3">
      <IpponHSpace align="middle" gap={16}>
        <IpponIconTile icon={{ name: 'hardware-chip', variant: 'sharp' }} size="large" />
        <IpponHSpaceSlot expand={true}>
          <IpponVSpace gap={4} align="left">
            <IpponText variant="body" color="neutral-tertiary-inversed" placeholder />
            <IpponText variant="label" size="large" placeholder />
          </IpponVSpace>
        </IpponHSpaceSlot>
        <IpponIcon size={24} name="chevron-forward" />
      </IpponHSpace>
    </IpponCard>
  </LoadingSkeleton>
);
